const csmstimetable = {
  namespaced: true,
  state: {
    applyObj: {},
    online: {}, //在线选课
    currentStudent: {},
    studentVal: {
      schooleVal: {},
      yearVal: {},
      classVal: {}
    }
  },
  mutations: {
    setApplyObj(state, applyObj) {
      //调代课申请的详情
      state.applyObj = applyObj
    },
    setOnline(state, online) {
      //在线选课
      state.online = online
    },
    setCurrentStudent(state, value) {
      state.currentStudent = value
    },
    setStudentVal(state, value) {
      state.studentVal = value
    }
  }
}
export default csmstimetable
